import axios from "axios";
import { LoginResponse, UserData } from "../types/user";

const baseUrl = process.env.REACT_APP_AUTH_SERVICE_BASE_URL;

export type LoginType = "admin" | "partner";

/**
 * Login for Teracar Admin/Agent/BackOffice
 */
export const loginAdmin = async (body: UserData): Promise<LoginResponse | undefined> => {
  let response: LoginResponse | undefined;
  try {
    // Convert email to lowercase before sending to backend
    const requestBody = {
      ...body,
      email: body.email.toLowerCase().trim(),
    };
    const res = await axios.post(`${baseUrl}/auth/v1/admin/login`, requestBody);
    response = {
      status: res.status,
      data: res.data,
    };
  } catch (error: any) {
    console.log("Admin login error:", error);
    response = error;
  }
  return response;
};

/**
 * Login for Teracar Partner/PartnerAgent
 */
export const loginPartner = async (body: UserData): Promise<LoginResponse | undefined> => {
  let response: LoginResponse | undefined;
  // Convert email to lowercase before sending to backend
  const email = body.email.toLowerCase().trim();
  try {
    // Try partner login first
    const res = await axios.post(
      `${baseUrl}/auth/v1/auth/login/partner`,
      {
        identifier: email,
        password: body.password,
        type: "email",
      }
    );
    response = {
      status: res.status,
      data: res.data,
    };
  } catch (error: any) {
    // If partner login fails, try partner-agent login
    try {
      const res = await axios.post(
        `${baseUrl}/auth/v1/auth/login/partner-agent`,
        {
          identifier: email,
          password: body.password,
          type: "email",
        }
      );
      response = {
        status: res.status,
        data: res.data,
      };
    } catch (agentError: any) {
      console.log("Partner login error:", agentError);
      response = agentError;
    }
  }
  return response;
};

/**
 * Legacy login function - kept for backward compatibility
 * @deprecated Use loginAdmin or loginPartner instead
 */
export const login = async (body: UserData): Promise<LoginResponse | undefined> => {
  // Convert email to lowercase before sending to backend
  const requestBody = {
    ...body,
    email: body.email.toLowerCase().trim(),
  };
  return loginAdmin(requestBody);
};
